import { Dayjs } from 'dayjs';
import { settings } from 'settings';
import { toIsoDate } from 'utils/date';
import Fetch from 'utils/fetch';
import { queryStringFromObject } from 'utils/urlUtil';

export interface CourierScore {
  courierId: string;
  averageRating: number;
  totalOrders: number;
  totalDeliveries: number;
  startTime: string;
  endTime: string;
}

export interface CourierAvgRating {
  averageRatingAllTime: number;
}

export async function fetchCouriersScore(
  start: string,
  end: string
): Promise<CourierScore | null> {
  const bodyToSend = {
    start: start,
    end: end,
  };

  try {
    const response: Response = await Fetch.post({
      url: `${settings.newApiUrl}/order/courierScore`,
      body: bodyToSend,
    });

    return response.ok ? await response.json() : null;
  } catch (e) {
    console.log(`Error fetching courier score`, e);
    return null;
  }
}

// Fetches all-time courier rating for the logged in courier
export async function fetchCourierAvgRating(): Promise<CourierAvgRating | null> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/order/courierRating`,
    });

    return response.ok ? await response.json() : null;
  } catch (e) {
    console.log(`Error fetching courier score`, e);
    return null;
  }
}

// Fetches average rating over a specific period
export const fetchRating = async (
  startDate: Dayjs,
  endDate: Dayjs,
  region: string,
  courierId?: number | string
): Promise<number | null> => {
  const params = queryStringFromObject({
    courierId,
    region,
    start: toIsoDate(startDate),
    end: toIsoDate(endDate),
  });
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/courier/rating${params}`,
  });
  const data = await response.text();
  return data ? Number(parseFloat(data).toFixed(1)) : null;
};
